exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter-section[data-v-f506815a]{margin-bottom:1rem}.table-container[data-v-f506815a]{overflow-x:auto;margin-bottom:1rem}.content-preview[data-v-f506815a]{max-width:300px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.icon-margin[data-v-f506815a]{margin-right:.25rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f506815a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/organisms/contents/ReminderListModal.vue
// module id = e18i
// module chunks = 3